import { Avatar } from "@mui/material";

export const getInitials = (name = "") =>
  name
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0].toUpperCase())
    .join("");

// Users are shown by the initials of their name. Profile pictures are not
// used: they were IPFS hashes entered by hand and loaded from a public
// gateway, slow and rarely set.
const UserAvatar = ({ name, size = 36, sx }) => (
  <Avatar
    alt={name}
    sx={{
      width: size,
      height: size,
      fontSize: Math.round(size * 0.4),
      fontWeight: 600,
      bgcolor: "#1e3a5f",
      ...sx,
    }}
  >
    {getInitials(name)}
  </Avatar>
);

export default UserAvatar;
